export const PDF_CONFIG = {
  scale: 2,
  useCORS: true,
  allowTaint: true,
  backgroundColor: '#ffffff',
  logging: false,
  format: 'a4',
  orientation: 'portrait',
  unit: 'pt'
};

export const PDF_STYLES = {
  container: {
    backgroundColor: "white",
    padding: "40px",
    minHeight: "297mm", // A4 height
    maxWidth: "210mm", // A4 width
    margin: "0 auto",
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#333",
    fontFamily: "Arial, sans-serif",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)"
  },
  logo: {
    maxWidth: "200px",
    height: "auto",
    marginBottom: "20px"
  },
  divider: {
    my: 2,
    backgroundColor: "#667eea",
    height: "2px"
  },
  reportContainer: {
    overflow: "auto",
    maxHeight: "80vh"
  }
};

export const generatePDFOptions = (element) => ({
  ...PDF_CONFIG,
  width: element.scrollWidth,
  height: element.scrollHeight,
  onclone: (clonedDoc) => {
    const clonedCanvases = clonedDoc.querySelectorAll('canvas');
    clonedCanvases.forEach(canvas => {
      if (canvas.width === 0) canvas.width = 400;
      if (canvas.height === 0) canvas.height = 400;
    });
  },
  ignoreElements: () => false
});

export const calculatePDFDimensions = (pdf, canvas) => {
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  const imgWidth = canvas.width;
  const imgHeight = canvas.height;
  const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
  const imgX = (pdfWidth - imgWidth * ratio) / 2;
  const imgY = 10;

  return {
    imgX,
    imgY,
    width: imgWidth * ratio,
    height: imgHeight * ratio
  };
};